import React, { useEffect, useState } from 'react';

import { IconType } from 'react-icons/lib';
import { Link } from 'react-router-dom';
import VideoGallery from '../../../../components/VideoGallery';
import api from '../../../../services/api';

import { Container } from './styles';



interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

interface IVideos {
  title?: string;
  video_id: string;
  type_id: string;
  className?: string;
}

const TendaAlimentacao: React.FC = () => {

  const [videos,setVideos] = useState<Array<IVideos>>([]);

  const load = async () => {
    const response = await api.get('/video-gallery/3');

    if(response){

   
      setVideos(response?.data?.videos || []);
    }
  }
  useEffect(() => {

    load();

    window.scrollTo(0,0);

  },[])
  return (
    <>


      <Container>
        <div className="title_div">
        <img className="tenda_title" src="/apoio/tenda/encontro_como_alimento_title.png"/>

        <Link className="tenda_back" to="/tenda-paulo-freire">
          Voltar
        </Link>

        </div>

        <div style={{width:'100%'}}>
          <VideoGallery data={videos}/>
        </div>

        <div className="tenda_ground_div">
          <div>
            <img className="tenda_ground" src="/apoio/tenda/canto_tenda.png"/>
            <img className="tenda_image" src="/apoio/tenda/encontro_como_alimento.png"/>
            </div>
        </div>
      </Container>
    </>
  );
};
export default TendaAlimentacao;
